import { styled } from "styled-components";

export const BoardContainer = styled.div``;
export const BoardWrapper = styled.div`
  padding: 80px 0;
  @media all and (max-width: 768px) {
    padding: 13.021vw 0;
  }
`;
export const BoardWrap = styled.div``;

export const BoardListWrapper = styled.ul`
  gap: 32px;
  flex-wrap: wrap;
  display: flex;
  li {
    width: calc(33.333% - 64px / 3);
    a {
      display: flex;
      flex-direction: column;
      gap: 24px;
      .img-wrap {
        border-radius: 8px;
        width: 100%;
        height: 372px;
        border: 1px solid #efefef;
        overflow: hidden;
        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
      }
      .text-wrap {
        display: flex;
        flex-direction: column;
        gap: 8px;
        h4 {
          text-align: left;
          font-size: 16px;
          line-height: 1.5;
          color: #555;
          font-weight: bold;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
          overflow: hidden;
          text-overflow: ellipsis;
          word-break: break-word;
        }
        p {
          text-align: left;
          font-size: 14px;
          line-height: 1.5;
          color: #6f6f6f;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
          overflow: hidden;
          text-overflow: ellipsis;
          word-break: break-word;
        }
        span {
          text-align: left;
          font-size: 12px;
          line-height: 1.5;
          color: #6f6f6f;
        }
      }
    }
  }
  @media all and (max-width: 1180px) {
    gap: 16px;
    li {
      width: calc(33.333% - 32px / 3);
      a {
        gap: 18px;
        .img-wrap {
          height: 31.356vw;
        }
      }
    }
  }
  @media all and (max-width: 900px) {
    li {
      width: calc(50% - 16px / 2);
      a {
        .img-wrap {
          height: 38.889vw;
        }
      }
    }
  }
  @media all and (max-width: 500px) {
    gap: 4.8vw;

    li {
      width: 100%;
      a {
        gap: 2.8vw;
        .img-wrap {
          height: auto;
        }
        .text-wrap {
          gap: 8px;
          h4 {
            font-size: 4.4vw;
          }
          p {
            font-size: 4vw;
          }
          span {
            font-size: 4vw;
          }
        }
      }
    }
  }
`;

export const Pagination = styled.div`
  display: flex;
  justify-content: center;
  gap: 8px;
  margin-top: 32px;

  button {
    width: 26px;
    height: 26px;
    /* background: #007bff; */
    font-size: 14px;
    line-height: 20px;
    border-radius: 50%;
    background: transparent;
    border: 0 none;
    cursor: pointer;
    transition: all 0.3s ease-in-out;
    color: #555555;

    > i {
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    &.active {
      background: #233e99;
      color: white;
      font-weight: bold;
    }

    &:disabled {
      cursor: not-allowed;
      opacity: 0.5;
    }
    &.disabled {
      display: none;
    }

    img {
      width: 16px;
      height: 16px;
    }
  }
  @media all and (max-width: 500px) {
    gap: 2.4vw;
    margin-top: 7.2vw;
    button {
      width: 6vw;
      height: 6vw;
      font-size: 4vw;
      line-height: 1.2;
      img {
        width: 4.4vw;
        height: 4.4vw;
      }
    }
  }
`;
